import React from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '@src/store'
import type { IActionsCallbacks } from '@src/interfaces'
import { EditableForm } from '@src/modules/organisms/editable'
import styles from './styles.module.scss'

interface INewTemplate {
  templateHeaderNode: React.ReactNode
  actionsCallback?: IActionsCallbacks
  isSignatureFlow?: boolean
  biometric?: boolean
  documentType?: boolean
  tags?: boolean
  t?: AnimationPlayState
  handleReturn?: () => void
  variableVisibility?: () => void
  handleSearch?: () => void
  filterWorkspaceCallback?: (key: string) => boolean
}

const NewTemplate: React.FC<INewTemplate> = ({
  templateHeaderNode,
  actionsCallback,
  isSignatureFlow,
  biometric,
  documentType,
  tags,
  t,
  handleReturn,
  variableVisibility,
  handleSearch,
  filterWorkspaceCallback,
}) => {
  const { newTemplate } = useSelector(
    ({ configuration }: RootState) => configuration
  )

  return (
    <div>
      <h1 className={styles.title}>General</h1>
      <EditableForm
        template={newTemplate}
        isNew
        isSignatureFlow={isSignatureFlow}
        biometric={biometric}
        documentType={documentType}
        tags={tags}
        templateHeaderNode={templateHeaderNode}
        actionsCallback={actionsCallback}
        t={t}
        handleReturn={handleReturn}
        variableVisibility={variableVisibility}
        handleSearch={handleSearch}
        filterWorkspaceCallback={filterWorkspaceCallback}
      />
    </div>
  )
}

export default NewTemplate
